import { Mark } from 'tiptap'
// 支持下标
export default class SubscriptMark extends Mark {
    get name() {
      return 'SubscriptMark';
    }
    get schema() {
      return {
        parseDOM: [
          { 
            tag: 'sub'
          },
        ],
        toDOM: () => ['sub', 0],
      }
    }
  }
